import type { ThreadItem } from "./api";

/**
 * The Chats tabs (spec §7.1). Only Mine shows for now (decided 2026-09-26):
 * Everyone is parked until workspaces have more people (slice 6), and
 * "Waiting on me" arrives with decisions in slice 3. Mine is filtered by the
 * Worker (`?mine=1`), so each tab pages on its own.
 */
export type ThreadTab = "everyone" | "mine";

/**
 * The loaded threads a tab shows, and what to say when there are none. The
 * list reads like a channel: oldest at the top, the newest last, just above
 * the composer. The pages come newest first, so they're turned over here.
 */
export function threadsFor(
  pages: Array<{ threads: ThreadItem[] }>,
  tab: ThreadTab,
): { shown: ThreadItem[]; empty: string | null } {
  const shown = pages.flatMap((p) => p.threads).reverse();
  if (shown.length > 0) return { shown, empty: null };
  const none = tab === "mine" ? "You haven't started a thread yet." : "No threads yet.";
  return { shown, empty: `${none} Ask for something below.` };
}
